export default "__VITE_ASSET__27b087db__"